var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('topic-navigation-link',{attrs:{"active":_vm.active,"to":_vm.route,"badge":_vm.unseenContentCount}},[_vm._v(" "+_vm._s(_vm.topic.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }